import React from 'react';
import NoSessionIcon from "../../assets/images/chatbot/empty-session.svg";
import NoSearchListIcon from "../../assets/images/survey/reports/no-images.png";


function NoData({ isSearch }) {
    return (
        <div className={`empty-container ${isSearch ? 'empty-search' : ''}`}>
            <img src={isSearch ? NoSearchListIcon : NoSessionIcon} />
            <p>{isSearch ? "No results found" : "No data found!"}</p>
        </div>
    )
}

export default NoData